import axios from "axios";
import { Config } from "../../data/config";

export const SET_RECENT_BUILDINGS = "SET_RECENT_BUILDINGS";

export function setRecentBuildings(buildings){
  return { type: SET_RECENT_BUILDINGS, payload: buildings };
};

export function getRecentBuildings()
{
  return function(dispatch) {
      axios
      .get(`${Config.frontApiUrl}/availability/recent`)
      .then(response => {
        dispatch(setRecentBuildings(response.data.buildings));
      })
      .catch(errors => {});
  };
}


// WEBPACK FOOTER //
// ./src/store/actions/recentBuildings.js